/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityEvent } from './ActivityEvent';
import {
    ActivityEventFromJSON,
    ActivityEventFromJSONTyped,
    ActivityEventToJSON,
    ActivityEventToJSONTyped,
} from './ActivityEvent';

/**
 * Cursor-based activity feed response
 * @export
 * @interface ActivityFeedResponse
 */
export interface ActivityFeedResponse {
    /**
     * 
     * @type {Array<ActivityEvent>}
     * @memberof ActivityFeedResponse
     */
    events: Array<ActivityEvent>;
    /**
     * Whether there are more events available
     * @type {boolean}
     * @memberof ActivityFeedResponse
     */
    hasMore: boolean;
    /**
     * Cursor to use for fetching the next page
     * @type {number}
     * @memberof ActivityFeedResponse
     */
    nextCursor?: number | null;
}

/**
 * Check if a given object implements the ActivityFeedResponse interface.
 */
export function instanceOfActivityFeedResponse(value: object): value is ActivityFeedResponse {
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function ActivityFeedResponseFromJSON(json: any): ActivityFeedResponse {
    return ActivityFeedResponseFromJSONTyped(json, false);
}

export function ActivityFeedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityFeedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(ActivityEventFromJSON)),
        'hasMore': json['hasMore'],
        'nextCursor': json['nextCursor'] == null ? undefined : json['nextCursor'],
    };
}

export function ActivityFeedResponseToJSON(json: any): ActivityFeedResponse {
    return ActivityFeedResponseToJSONTyped(json, false);
}

export function ActivityFeedResponseToJSONTyped(value?: ActivityFeedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': ((value['events'] as Array<any>).map(ActivityEventToJSON)),
        'hasMore': value['hasMore'],
        'nextCursor': value['nextCursor'],
    };
}

